// extracted by mini-css-extract-plugin
export default {"Overlay":"_Overlay--HMJeZ","Trigger":"_Trigger--nnx51","Content":"_Content--J334T","DragHandle":"_DragHandle--Qoke5","Title":"_Title--uXNXy"};